var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('spinner-container',{attrs:{"loading":_vm.localLoading}},[_c('back-btn'),_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('Form',{attrs:{"clinic":_vm.clinic},on:{"emitDaData":_vm.update}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }